import * as React from 'react';
import { IconButton } from '@cian/frontend-reviews-components';
import { IconSocialLikeOn16, IconSocialDislikeOn16 } from '@cian/ui-kit-design-tokens/icons';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-restricted-paths
import { setReviewReaction } from '../../../browser/services/reviews/setReviewReaction';
// eslint-disable-next-line import/no-restricted-paths
import { ILikeSchema, EStatus } from '../../../node/repositories/newbuilding-card/entities/reviews/LikeSchema';
import { requestAuthentication } from '../../actions/authentication';
import { ReviewsReactions } from '../../components/ReviewsReactions';
import { getIsAuthenticated } from '../../selectors/newbuilding';

export interface IReviewsReactionsContainerProps {
  reviewId: string;
  reactions: ILikeSchema;
}

export const ReviewsReactionsContainer: React.FC<IReviewsReactionsContainerProps> = ({ reviewId, reactions }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const setAnswerLike = React.useCallback(() => setReviewReaction({ reviewId, type: EStatus.Liked }), []);
  const setAnswerDislike = React.useCallback(() => setReviewReaction({ reviewId, type: EStatus.Disliked }), []);

  const onLikeClick = React.useCallback(() => {
    if (isAuthenticated) {
      // @ts-expect-error
      dispatch(setAnswerLike());
    } else {
      // @ts-expect-error
      dispatch(requestAuthentication({ onSuccess: setAnswerLike }));
    }
  }, [dispatch, isAuthenticated, setAnswerLike, requestAuthentication]);

  const onDislikedClick = React.useCallback(() => {
    if (isAuthenticated) {
      // @ts-expect-error
      dispatch(setAnswerDislike());
    } else {
      // @ts-expect-error
      dispatch(requestAuthentication({ onSuccess: setAnswerDislike }));
    }
  }, [dispatch, isAuthenticated, setAnswerLike, requestAuthentication]);

  return (
    <ReviewsReactions
      like={
        <IconButton
          Icon={IconSocialLikeOn16}
          active={reactions.status === EStatus.Liked}
          onClick={onLikeClick}
          label={reactions.likesCount}
        />
      }
      dislike={
        <IconButton
          Icon={IconSocialDislikeOn16}
          active={reactions.status === EStatus.Disliked}
          onClick={onDislikedClick}
          label={reactions.dislikesCount}
        />
      }
    />
  );
};
